/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account information — When you create an account, we collect your name, email address, and authentication credentials.`)
};

const es_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de cuenta — Cuando creas una cuenta, recopilamos tu nombre, dirección de correo electrónico y credenciales de autenticación.`)
};

const de_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontoinformationen — Wenn Sie ein Konto erstellen, erfassen wir Ihren Namen, Ihre E-Mail-Adresse und Ihre Authentifizierungsdaten.`)
};

const nl_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accountinformatie — Wanneer u een account aanmaakt, verzamelen we uw naam, e-mailadres en inloggegevens.`)
};

const fr_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de compte — Lorsque vous créez un compte, nous collectons votre nom, votre adresse e-mail et vos identifiants d’authentification.`)
};

const it_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni account — Quando crei un account, raccogliamo il tuo nome, indirizzo e-mail e credenziali di autenticazione.`)
};

const pt_br2_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações da conta — Ao criar uma conta, coletamos seu nome, endereço de e-mail e credenciais de autenticação.`)
};

const pt_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informação da conta — Quando cria uma conta, recolhemos o seu nome, endereço de e-mail e credenciais de autenticação.`)
};

const ja_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント情報 — アカウント作成時に、氏名、メールアドレス、認証情報を収集します。`)
};

const zh_privacy_info_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户信息 — 当您创建账户时，我们会收集您的姓名、电子邮件地址和认证凭据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_info_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_info_account(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_info_account", locale)
	if (locale === "en") return en_privacy_info_account(inputs)
	if (locale === "es") return es_privacy_info_account(inputs)
	if (locale === "de") return de_privacy_info_account(inputs)
	if (locale === "nl") return nl_privacy_info_account(inputs)
	if (locale === "fr") return fr_privacy_info_account(inputs)
	if (locale === "it") return it_privacy_info_account(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_info_account(inputs)
	if (locale === "pt") return pt_privacy_info_account(inputs)
	if (locale === "ja") return ja_privacy_info_account(inputs)
	return zh_privacy_info_account(inputs)
};